import { Button } from '@neo/index'
import { ReactComponent as VibeMascot } from '@shared/assets/icons/vibe-mascot.svg'
import { useFlowRunStore } from '../../../run-info/store'
import { useFlowStore } from '../../../store'
import { useVibeAgentHidden } from './use-vibe-agent-gate'

export const VibeAgentToggleButton = () => {
  const showVibeSidebar = useFlowStore((state) => state.showVibeSidebar)
  const setShowVibeSidebar = useFlowStore((state) => state.setShowVibeSidebar)
  const setPanelState = useFlowRunStore((state) => state.setPanelState)

  const vibeAgentHidden = useVibeAgentHidden()
  const handleClick = () => {
    setShowVibeSidebar(!showVibeSidebar)
    if (!showVibeSidebar && useFlowRunStore.getState().panelState === 'maximized') {
      setPanelState('minimized')
    }
  }

  if (vibeAgentHidden) {
    return null
  }

  return (
    <div className="vibe-agent-theme relative">
      <Button
        variant="outline"
        size="sm"
        typography="action"
        onClick={handleClick}
        data-testid="button-toggle-vibe-agent"
        aria-pressed={showVibeSidebar}
        className="pl-8 items-center border-brand text-foreground"
      >
        Vibe Agent
      </Button>
      <VibeMascot className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 h-5 w-5 -mt-0.5" />
    </div>
  )
}
